export default class NotificationMessage {

  private readonly _value: string;

  constructor(value: string) {
    this._value = value;
  }

  public isEqualTo(other: NotificationMessage): boolean {
    return this.value === other?.value;
  }

  public get value(): string {
    return this._value;
  }

  public static get Prototype(): NotificationMessage {
    return new NotificationMessage("");
  }

  public fromJSON(value: string): NotificationMessage {
    return new NotificationMessage(value);
  }
  public toJSON(): string {
    return this.value;
  }
  public clone(): NotificationMessage {
    return new NotificationMessage(this.value);
  }
}
